import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IShift } from 'src/app/modules/core/interfaces/shift';
import { IMachineContext } from '../../../../../../../../projects/common/src/app/interfaces/machine-context';
import { IShiftWidget } from '../../../../interfaces/shift-widget';
import { PermissionService } from 'src/app/modules/core/services/parameter/permission/permission.service';
import { EPermissions } from 'projects/common/src/app/enumerables/permissions';
import { getUnits, firstLetterUpper } from 'projects/common/src/app/services/utils/utilities';
import { LanguageService } from 'projects/common/src/app/services/parameters';

@Component({
  selector: 'app-shift-selector',
  templateUrl: './shift-selector.component.html',
  styleUrls: ['./shift-selector.component.scss'],
})
export class ShiftSelectorComponent implements IShiftWidget, OnInit {
  public readonly PERMISSION_OBJECT = 'LEY DE MINERAL';
  public canVisualize = false;
  /**
   * Objeto de referencia a un turno
   */
  @Input()
  public shift: IShift;

  /**
   * Objeto de referencia a los numeradores
   */
  @Input()
  public set numerator(numerator: string) {
    const machineType = sessionStorage.getItem('machine-context');
    this.unit = getUnits(firstLetterUpper(JSON.parse(machineType).name), this.shift.totalMeasure, this.langService);
  }

  /**
   * Objeto de referencia a los denominadores
   */
  @Input()
  public set denominator(denominator: string) {
    this.quantity = denominator;
  }

  /**
   * Si muestra o no la información correspondiente al tipo de máquina
   */
  @Input()
  public set hasProduction(hasProduction: boolean) {
    this.showProduction = hasProduction;
  }

  /**
   * Evento para emitir la selección de una referencia a un turno
   */
  @Output()
  public shiftSelected: EventEmitter<IShift>;

  public unit: string;
  public quantity: string;
  public showProduction: boolean;
  public machineContext: IMachineContext;

  constructor(private permissionService: PermissionService, private langService: LanguageService) {
    this.shiftSelected = new EventEmitter<IShift>();
  }

  ngOnInit(): void {
    const machineType = sessionStorage.getItem('machine-context');
    this.unit = getUnits(firstLetterUpper(JSON.parse(machineType).name), this.shift?.totalMeasure, this.langService);
    this.machineContext = JSON.parse(machineType).name;

    const permissions = this.permissionService.getPermissionsByObj(this.PERMISSION_OBJECT);
    this.canVisualize = permissions.some(({ permission }) => permission.toLowerCase() === EPermissions.VISUALIZE.toLowerCase());
  }

  /**
   * Function that emit the shift selected
   */
  public selectShift(): void {
    this.shiftSelected.emit(this.shift);
  }
}
